// ===== host =====
export const isHostLogin = () => {
  return sessionStorage.getItem('is_host') === 'true';
};

export const getHost = () => {
  if (!isHostLogin()) return null;

  return {
    email: sessionStorage.getItem('host_email'),
  };
};

// ===== user =====
export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// ===== logout（共通） =====
export const logout = (navigate) => {
  if (isHostLogin()) {
    sessionStorage.clear();
    navigate('/login/host', { replace: true });
    return;
  }

  localStorage.removeItem('user');
  sessionStorage.clear();
  navigate('/', { replace: true });
};
